import { View, Text, styled, useTheme } from 'tamagui'
import { X } from '@tamagui/lucide-icons'
import { useState } from 'react'
import { useAppStore } from '@/store'

const Backdrop = styled(View, {
  position: 'absolute',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  // @ts-expect-error -- web backdrop-filter
  style: { backdropFilter: 'blur(8px)' },
  zIndex: 2000,
  alignItems: 'center',
  justifyContent: 'center',
})

const Modal = styled(View, {
  width: 440,
  backgroundColor: '$surfaceRaised',
  borderRadius: '$borderRadiusXl',
  borderWidth: 1,
  borderColor: '$borderDefault',
  overflow: 'hidden',
})

const ModalHeader = styled(View, {
  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
  paddingHorizontal: 20, paddingVertical: 16,
  borderBottomWidth: 1, borderBottomColor: '$borderDefault',
})

const ModalTitle = styled(Text, {
  fontFamily: '$fontHeading', fontWeight: '600', fontSize: 18, color: '$surfaceForeground',
})

const ModalBody = styled(View, { padding: 20, gap: 16 })

const CloseButton = styled(View, {
  width: 28, height: 28, borderRadius: '$borderRadiusMd', alignItems: 'center', justifyContent: 'center',
  cursor: 'pointer', hoverStyle: { backgroundColor: '$sidebarHover' },
})

const SendButton = styled(View, {
  height: 40, borderRadius: '$borderRadiusLg', alignItems: 'center', justifyContent: 'center',
  backgroundColor: '$accent', cursor: 'pointer',
  hoverStyle: { opacity: 0.9 },
})

export function AddFriendModal() {
  const { closeAddFriendModal } = useAppStore()
  const theme = useTheme()
  const [username, setUsername] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSend = () => {
    if (!username.includes('#')) {
      setError('Please use the format username#0000')
      return
    }
    setSent(true)
    setTimeout(() => {
      closeAddFriendModal()
    }, 2000)
  }

  return (
    <Backdrop onPress={closeAddFriendModal}>
      <Modal
        onPress={(e: any) => e.stopPropagation()}
        // @ts-expect-error -- web box-shadow
        style={{ boxShadow: theme.shadowModal?.val || 'none' }}
      >
        <ModalHeader>
          <ModalTitle>Add Friend</ModalTitle>
          <CloseButton onPress={closeAddFriendModal}>
            <X size={16} color="$sidebarMuted" />
          </CloseButton>
        </ModalHeader>

        <ModalBody>
          {sent ? (
            <View alignItems="center" paddingVertical={16} gap={8}>
              <Text fontSize={24}>✓</Text>
              <Text fontFamily="$fontBody" fontSize={14} color="$surfaceForeground">
                Friend request sent to {username}!
              </Text>
            </View>
          ) : (
            <>
              <Text fontFamily="$fontBody" fontSize={13} color="$sidebarMuted">
                You can add friends with their Arcus username and discriminator.
              </Text>

              <View gap={6}>
                <Text fontFamily="$fontBody" fontSize={12} fontWeight="600" color="$color8" textTransform="uppercase" letterSpacing={0.5}>
                  Username
                </Text>
                <input
                  value={username}
                  onChange={(e) => { setUsername(e.target.value); setError('') }}
                  onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                  placeholder="username#0000"
                  style={{
                    background: 'transparent',
                    border: `1px solid ${error ? '#CF3E4F' : (theme.borderDefault?.val || '#2A3142')}`,
                    borderRadius: 6, padding: '10px 14px',
                    color: theme.surfaceForeground?.val || '#E2E8F0',
                    fontFamily: '$fontMono', fontSize: 14,
                    outline: 'none', width: '100%', boxSizing: 'border-box',
                  }}
                />
                {error && (
                  <Text fontFamily="$fontBody" fontSize={12} color="$error">{error}</Text>
                )}
              </View>

              <SendButton
                onPress={handleSend}
                // @ts-expect-error -- web box-shadow
                style={{ boxShadow: theme.shadowButton?.val }}
              >
                <Text fontFamily="$fontBody" fontWeight="600" fontSize={14} color="$surface">
                  Send Friend Request
                </Text>
              </SendButton>
            </>
          )}
        </ModalBody>
      </Modal>
    </Backdrop>
  )
}
